// extracted by mini-css-extract-plugin
export default {"title":"_4ead2b1825","inner_title":"_64b44ca4c0","charge_btn":"acada74e11"};